module.exports = __webpack_public_path__ + "img/ethernal.e518edd6.svg";